// extracted by mini-css-extract-plugin
export default {"pageRoot":"liquidShell_pageRoot__5CtNF","liquidBgLayer":"liquidShell_liquidBgLayer__6P37e","pageMain":"liquidShell_pageMain__zAk38"};